import React from "react";
import Icon, { IconType } from "./Icon";
import { BtnState } from "../interfaces/App";

interface IProps {
    open: boolean;
    classNames: string;
    onClick: (open: boolean) => void;
    icons: IconType[];
}
function TopMenu(props: React.PropsWithChildren<IProps>) {
    return (
        <div className={props.classNames} onClick={(ev: any) => {ev.stopPropagation(); props.onClick(!props.open)}} >
            <Icon className="topIcon" icon={props.open ? props.icons[0] : props.icons[1]} state={BtnState.active} />
            {props.open && <div className="mobileMenue">{props.children}</div>}
        </div>
    );
}
export default (TopMenu);
